import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";

import Header from "./components/Header/Header";
import HomePage from "./pages/HomePage/HomePage";
import ContactPage from "./pages/ContactPage/ContactPage";
import BankIntegrationPage from "./pages/BankIntegrationPage/BankIntegrationPage";
import AuthenticationAndSigningPage from "./pages/AuthenticationAndSigningPage/AuthenticationAndSigningPage";
import UserRightsManagementPage from "./pages/UserRightsManagementPage/UserRightsManagementPage";
import SupportAndMaintenancePage from "./pages/SupportAndMaintenancePage/SupportAndMaintenancePage";
import ScheduledTasksPage from "./pages/ScheduledTasksPage/ScheduledTasksPage";
import DataMigrationPage from "./pages/DataMigrationPage/DataMigrationPage";
import UserTrainingPage from "./pages/UserTrainingPage/UserTrainingPage";
import CustomDevelopmentPage from "./pages/CustomDevelopmentPage/CustomDevelopmentPage";
import AutomaticBankReconciliationPage from "./pages/AutomaticBankReconciliationPage/AutomaticBankReconciliationPage";
import ElectronicInvoicingPage from "./pages/ElectronicInvoicingPage/ElectronicInvoicingPage";
import ERPAndCRMIntegrationPage from "./pages/ERPAndCRMIntegrationPage/ERPAndCRMIntegrationPage";
import IncomingInvoiceProcessingPage from "./pages/IncomingInvoiceProcessingPage/IncomingInvoiceProcessingPage";
import ComprehensiveFinancialManagementPage from "./pages/ComprehensiveFinancialManagementPage/ComprehensiveFinancialManagementPage";
import CustomizationsPage from "./pages/CustomizationsPage/CustomizationsPage";
import OnboardingWizard from "./pages/OnboardingWizard/OnboardingWizard";

import "./assets/scss/theme.scss";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/bank-integration" element={<BankIntegrationPage />} />
              <Route path="/authentication-and-signing" element={<AuthenticationAndSigningPage />} />
              <Route path="/user-rights-management" element={<UserRightsManagementPage />} />
              <Route path="/support-and-maintenance" element={<SupportAndMaintenancePage />} />
              <Route path="/scheduled-tasks" element={<ScheduledTasksPage />} />
              <Route path="/data-migration" element={<DataMigrationPage />} />
              <Route path="/user-training" element={<UserTrainingPage />} />
              <Route path="/custom-development" element={<CustomDevelopmentPage />} />
              <Route path="/automatic-bank-reconciliation" element={<AutomaticBankReconciliationPage />} />
              <Route path="/electronic-invoicing" element={<ElectronicInvoicingPage />} />
              <Route path="/erp-crm-integration" element={<ERPAndCRMIntegrationPage />} />
              <Route path="/incoming-invoice-processing" element={<IncomingInvoiceProcessingPage />} />
              <Route path="/comprehensive-financial-management" element={<ComprehensiveFinancialManagementPage />} />
              <Route path="/customizations" element={<CustomizationsPage />} />
              <Route path="/onboarding" element={<OnboardingWizard />} />
            </Routes>
          </main>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
